import { render, staticRenderFns } from "./ReservationHistoryDetail.vue?vue&type=template&id=e778722c&scoped=true&"
import script from "./ReservationHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./ReservationHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e778722c",
  null
  
)

export default component.exports